import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Divider,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Container
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import axios from 'axios';
import AWS from 'aws-sdk';

import { toast } from 'react-toastify';
import './AddNotification.css';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Type } from 'react-toastify/dist/utils';

import 'react-quill/dist/quill.snow.css'; // Import the Quill styles
import ReactQuill, { Quill } from 'react-quill';
import { useRef } from 'react';

// AWS S3 Configuration
AWS.config.update({
  accessKeyId: 'AKIAWX5OXDFHSE3ZUKMI',
  secretAccessKey: '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',
  region: 'ap-south-1'
});

// Initial form values
const initialValues = {
  Receiver: '',
  Title: '',
  Content: '',
  membersIds: [],
  type: '',
  SubNotification: '',
  Description: '' // <-- Add this field

};

const validationSchema = Yup.object({
  Receiver: Yup.string().required('Please select a Receiver'),
  Title: Yup.string().required('Title is required'),
  type: Yup.string().required('Please select a type'),
  Description: Yup.string().max(500, 'Description cannot exceed 500 characters') // Optional validation

});

// AddNotification Component
const AddNotification = () => {
  const [image, setImage] = useState(null);
  const [imageErr, setImageErr] = useState(false);


  const [content, setContent] = useState(''); // State for ReactQuill content
  const [contentErr, setContentErr] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const navigate = useNavigate();
  const quillRef = useRef(null);
  const s3 = new AWS.S3();

  async function handleImageFile(e) {
    setImageErr(false);
    const file = e.target.files[0];
    const folderPath = 'community1/'; 
    if (file) {
      setImage(file.name);
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        // Key: `${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read', // Ensure this is set according to your permissions
        ContentType: file.type // Set the content type
      };

      try {
        console.log('Uploading to S3...', params);
        const { Location } = await s3.upload(params).promise();
        setImage(Location);
        console.log('Upload successful:', Location);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error(`Upload failed: ${error.message}`, {
          position: 'bottom-right'
        });
      }
    } else {
      setImageErr(true);
    }
  }


  // Fetch members for the dropdown
  const handleNotificationData = async () => {
    try {
      let data = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/members/getAll`
      );
      setNotificationData(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleNotificationData();
  }, []);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const selectedMembersIds = values.membersIds;
      const memberid = selectedMembersIds.map((data) => ({
        member: data
      }));
      // const plainTextContent = quillRef.current.getEditor().getText();
      // const cleanedContent = plainTextContent.replace(/\n/g, ' ');

      console.log(content, 'ddddddddddd');

      const requestBody = {
        ...values,
        image: image,
        membersIds: memberid,
        Type: values.type,
        SubNotification: values.SubNotification,
        Content: content
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/notifications/addnotification`,
          requestBody
        );
        console.log(response,"ddddddddddgdfsdfass");
        
        toast.success('Notification created successfully!', {
          position: 'bottom-right'
        });
        navigate('/notifications/list');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'An error occurred', {
          position: 'bottom-right'
        });
      }
    }
  });

  return (
    <Container maxWidth="lg">
      <Card>
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '10px',
            background: '#fff',
            padding: 15,
            margin: 30,
            borderRadius: 10
          }}
        >
          <Grid className="carrd-box" item xs={12}>
            <Card>
              <CardHeader
                title="Add Notification"
                titleTypographyProps={{
                  style: {
                    margin: 0,
                    width: '100%',
                    color: '#000',
                    fontWeight: 700,
                    fontSize: '25px',
                    marginBottom: '30px'
                  }
                }}
              />
            
              <CardContent>
                <Box
                  component="form"
                  sx={{ '& .MuiTextField-root': { m: 1, width: '35ch' } }}
                  noValidate
                  autoComplete="off"
                >
                  {/* {/ Type Dropdown /} */}
                  <div
                    className="Main-div-1"
                    style={{ margin: 9, position: 'relative' }}
                  >
                    <InputLabel className="heading-receiver" htmlFor="type">
                      Type
                    </InputLabel>
                    <Select
                      className="text-area-style22"
                      sx={{ width: '35ch', ml: 1 }}
                      label="Type"
                      value={values.type}
                      name="type"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="type"
                    >
                      <MenuItem value="Announcement">Announcement</MenuItem>
                      <MenuItem value="Notification">Notification</MenuItem>
                    </Select>
                    {errors.type && touched.type ? (
                      <p style={{ color: 'red' }}>{errors.type}</p>
                    ) : null}
                  </div>

                  {/* {/ Conditionally render fields based on type selection /} */}
                  {values.type === 'Notification' && (
                    <div
                      className="Main-div-1"
                      style={{
                        alignItems: 'flex-start',
                        display: 'flex',
                        gap: '10px'
                      }}
                    >
                      <div style={{ margin: 9, position: 'relative' }}>
                        <InputLabel
                          className="heading-receiver"
                          htmlFor="notification-type"
                        >
                          Select Type of Notification
                        </InputLabel>
                        <Select
                          className="text-area-style22"
                          sx={{ width: '35ch', ml: 1 }}
                          label="Test Options"
                          name="SubNotification" // Ensure this is the correct name
                          value={values.SubNotification}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="subNotification" // Ensure this is the correct id
                        >
                          <MenuItem value="General">General</MenuItem>
                          <MenuItem value="Important">Important</MenuItem>
                          <MenuItem value="Government">Government</MenuItem>
                          <MenuItem value="Personal">Personal</MenuItem>
                        </Select>
                      </div>
                    </div>
                  )}

                  {(values.type === 'Announcement' ||
                    values.type === 'Notification') && (
                    <div
                      className="Main-div-1"
                      style={{
                        alignItems: 'flex-start',
                        display: 'flex',
                        gap: '10px'
                      }}
                    >
                      <div style={{ margin: 9, position: 'relative' }}>
                        <InputLabel
                          className="heading-receiver"
                          htmlFor="receiver"
                        >
                          Receiver
                        </InputLabel>
                        <Select
                          className="text-area-style22"
                          sx={{ width: '35ch', ml: 1 }}
                          label="Receiver"
                          value={values?.Receiver}
                          name="Receiver"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="receiver"
                        >
                          <MenuItem value="All">All</MenuItem>

                          <MenuItem value="Member">Member</MenuItem>
                        </Select>
                        {errors.Receiver && touched.Receiver ? (
                          <p style={{ color: 'red' }}>{errors.Receiver}</p>
                        ) : null}
                      </div>

                      {values.Receiver === 'Member' && (
                        <div style={{ margin: 9, position: 'relative' }}>
                          <InputLabel
                            className="heading-receiver"
                            htmlFor="members"
                          >
                            Members
                          </InputLabel>
                          <Select
                            className="text-area-style22"
                            sx={{ width: '35ch', ml: 1 }}
                            multiple
                            value={values?.membersIds}
                            name="membersIds"
                            onChange={(event) => {
                              const { value } = event.target;
                              setFieldValue(
                                'membersIds',
                                typeof value === 'string'
                                  ? value.split(',')
                                  : value
                              );
                            }}
                            onBlur={handleBlur}
                            id="membersIds"
                            renderValue={(selected) => (
                              <div>
                                {selected.map((id) => {
                                  const selectedMember = notificationData.find(
                                    (member) => member._id === id
                                  );
                                  return (
                                    <Typography key={id} variant="body2">
                                      {selectedMember?.name}
                                    </Typography>
                                  );
                                })}
                              </div>
                            )}
                          >
                            {notificationData.map((member) => (
                              <MenuItem key={member._id} value={member._id}>
                                <Checkbox
                                  checked={
                                    values?.membersIds.indexOf(member._id) > -1
                                  }
                                />
                                <ListItemText primary={member.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      )}

                      <div style={{ margin: 9 }}>
                        <TextField
                          className="text-area-style22"
                          label="Title"
                          name="Title"
                          type="text"
                          value={values?.Title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.Title && touched.Title ? (
                          <p style={{ color: 'red' }}>{errors.Title}</p>
                        ) : null}
                      </div>

                                      {/* Image Upload Field */}
                  <div style={{ margin: 9, width: '32%' }}>
                    <div style={{ margin: 9 }}>
                      <input type="file" onChange={handleImageFile} />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <AttachFileIcon /> */}
                        {/* <label>Choose an Image</label> */}
                      </div>
                      {image && (
                        <img
                          src={image}
                          alt="Uploaded"
                          style={{ maxWidth: '170px' }}
                        />
                      )}
                    </div>
                  </div>
                    </div>
                  )}

            <div style={{ margin: 13, width: '32%' }}>
            <InputLabel shrink htmlFor="Description" style={{ marginBottom: 4 }}>
                      Push Notification Description
                      </InputLabel>
                <TextField
                  className="text-area-style22"
                  label="Description"
                  name="Description"
                  type="text"
                  value={values?.Description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  multiline
                  rows={3} // Adjust rows for better UX
                  sx={{ width: '100%', ml: 1 }} // Style for full width
                />
                {errors.Description && touched.Description ? (
                  <p style={{ color: 'red' }}>{errors.Description}</p>
                ) : null}

                </div>
                  {/* / Content and Image Upload / */}
                  <div className="Main-div-1" style={{padding:'8px'}}>
                    <div style={{ margin: 9, width: '100%' }}>
                    <InputLabel shrink htmlFor="Description" style={{ marginBottom: 4 }}>
                      Detailed Description
                      </InputLabel>
                      <ReactQuill
                        ref={quillRef}
                        value={content}
                        onChange={(value) => {
                          setContent(value);
                          setContentErr(false);
                        }}
                        placeholder="Add Content"
                        modules={{
                          toolbar: [
                            [{ bold: true }, { italic: true },{underline: true}],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ header: [1, 2, false] }],
                            [{ color: [] }], // Add color options
                            ['link'] // Add link (anchor tag) option
                          ]
                        }}
                        formats={[
                          'bold',
                          'italic',
                          'underline',
                          'list',
                          'header',
                          'color',
                          'link'
                        ]} // Add 'color' and 'link' to formats
                      />
                    </div>
                  </div>
                </Box>
              </CardContent>

           
              <div
                style={{
                  display: 'flex',
                  // justifyContent: 'flex-end',
                  margin: '30px'
                }}
              >
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </div>
            </Card>
          </Grid>
        </form>
      </Card>
    </Container>
  );
};

export default AddNotification;
